export function formatCurrencyVND(amount) {
  const numericAmount = parseFloat(amount);

  if (isNaN(numericAmount)) {
    return "N/A";
  }

  return numericAmount
    .toLocaleString("vi-VN", { style: "currency", currency: "VND" })
    .replace("₫", "đ");
}

export function roundCurrencyVND(amount) {
  const remainder = amount % 10000;
  if (remainder === 0) return amount;
  if (remainder >= 5000) {
    return amount + (10000 - remainder);
  } else {
    return amount - remainder;
  }
}

export function generateSlug(str) {
  return str
    .toLowerCase()
    .replace(/đ/g, "d")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9-\s]/g, "")
    .trim()
    .replace(/\s+/g, "-");
}

export function formatDate(dateString) {
  const date = new Date(dateString);

  const options = { day: "2-digit", month: "2-digit", year: "numeric" };
  const formatter = new Intl.DateTimeFormat("en-GB", options);
  return formatter.format(date);
}

export function getPaymentMethod(number) {
  switch (number) {
    case 1:
      return "Chuyển khoản ngân hàng";
    case 2:
      return "Chuyển khoản MoMo";
    case 3:
      return "Thanh toán khi nhận hàng";
    default:
      return "";
  }
}
